export type BatteryVariant = 'charging' | 'empty' | 'full';

export interface StatusBarProps {
  time?: string;
  /** Island/safe-area inset so the row clears the notch (default on). */
  inset?: boolean;
  /** 'charging' = green fill + bolt, 'empty' = outline only, 'full' = solid fill. */
  battery?: BatteryVariant;
}

function SignalBars() {
  return (
    <svg
      className='mk-statusbar__signal'
      viewBox='0 0 18 12'
      width='18'
      height='12'
      fill='none'
      aria-hidden='true'
    >
      <rect x='0' y='7' width='3' height='5' rx='0.75' fill='currentColor' />
      <rect x='5' y='5' width='3' height='7' rx='0.75' fill='currentColor' />
      <rect x='10' y='2.5' width='3' height='9.5' rx='0.75' fill='currentColor' />
      <rect x='15' y='0' width='3' height='12' rx='0.75' fill='currentColor' />
    </svg>
  );
}

function WifiIcon() {
  return (
    <svg
      className='mk-statusbar__wifi'
      viewBox='0 0 16 12'
      width='16'
      height='12'
      fill='none'
      aria-hidden='true'
    >
      <path
        d='M1.5 4.2C3.3 2.5 5.6 1.5 8 1.5c2.4 0 4.7 1 6.5 2.7'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
      />
      <path
        d='M3.7 6.8C4.9 5.7 6.4 5.1 8 5.1s3.1.6 4.3 1.7'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
      />
      <path
        d='M5.9 9.4c.6-.5 1.3-.8 2.1-.8s1.5.3 2.1.8'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
      />
      <circle cx='8' cy='11' r='1' fill='currentColor' />
    </svg>
  );
}

function BatteryIcon({ variant = 'full' }: { variant?: BatteryVariant }) {
  return (
    <svg
      className='mk-statusbar__battery'
      viewBox='0 0 28 14'
      width='28'
      height='14'
      fill='none'
      aria-hidden='true'
    >
      <rect
        x='0.75'
        y='0.75'
        width='22.5'
        height='12.5'
        rx='3.75'
        stroke='currentColor'
        strokeOpacity='0.35'
      />
      <path
        d='M24.5 4.5v5a1.5 1.5 0 0 0 1.5 1.5 1.5 1.5 0 0 0 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5 1.5 1.5 0 0 0-1.5 1.5Z'
        fill='currentColor'
        fillOpacity='0.4'
      />
      {variant === 'charging' ? (
        <>
          <rect x='2.25' y='2.25' width='19.5' height='9.5' rx='2' fill='#34c759' />
          <path d='M14.4 3.8 9.6 7.6h3l-.9 2.4 4.4-3.7h-3Z' fill='#ffffff' />
        </>
      ) : null}
      {variant === 'full' ? (
        <rect x='2.25' y='2.25' width='19.5' height='9.5' rx='2' fill='currentColor' />
      ) : null}
    </svg>
  );
}

export function StatusBar({
  time = '9:41',
  inset = true,
  battery = 'full',
}: StatusBarProps) {
  return (
    <div className={`mk-statusbar${inset ? ' mk-statusbar--inset' : ''}`}>
      <span className='mk-statusbar__time'>{time}</span>
      <span className='mk-statusbar__icons'>
        <SignalBars />
        <WifiIcon />
        <BatteryIcon variant={battery} />
      </span>
    </div>
  );
}
